module.exports = __webpack_public_path__ + "img/coor3.e62f9503.png";